import script from "./ArtPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtPage.vue?vue&type=script&setup=true&lang=ts"

import "./ArtPage.vue?vue&type=style&index=0&id=28b96508&lang=scss"

const __exports__ = script;

export default __exports__